import { computed } from 'vue'
import type { Item } from '@/interfaces'
import type { Ref } from '@vue/reactivity'

export function useResources(currentResources: Ref<any[]>, limit: number = 5) {

    const addResourceDisabled = computed(() => currentResources.value.length >= limit);
    const removeResourceDisabled = computed(() => currentResources.value.length === 0);
    const hasEmptyResources = computed(() => currentResources.value.length >= 1 && currentResources.value.some((resource: Item) => resource.amount === null || resource.amount === 0 || resource.id === null || resource.id === 0));

    function addResource(): void {
        currentResources.value = [...currentResources.value, { id: null, amount: null }];
    }

    function removeResource(): void {
        currentResources.value = currentResources.value.toSpliced(currentResources.value.length - 1, 1);
    }

    return {
        resources: currentResources,
        addResource,
        removeResource,
        hasEmptyResources,
        addResourceDisabled,
        removeResourceDisabled
    };
}